import loadable from '@loadable/component';

const Iconfont = loadable(() => import('./Iconfont'));

export default Iconfont;
